// extracted by mini-css-extract-plugin
export default {"disable_select":"projectsOwnListItems_disable_select__jBZP3","ownItems":"projectsOwnListItems_ownItems__IC5El","itemOverlay":"projectsOwnListItems_itemOverlay__rJuGX"};